import About from "./components/About";
import Contact from "./components/Contact";
import Home from "./components/Home";
import Navbar from "./components/Navbar"; // can click control + spacebar to autoimport when filling in div with components below
import Resume from "./components/Resume";
import Skills from "./components/Skills";
import Work from "./components/Work";

function App() {
  return (
    <div>
      <Navbar />
      <Home />
      <About />
      <Skills />
      <Work />
      <Resume />
      <Contact />
    </div>
  );
}

export default App;
